import { SearchPropsI } from "./Search.props";
import styles from "./Search.module.scss";
import { MULTISEARCH_DIVIDER, useSearchControl } from "./useSearchControl";
import { useIntl } from "react-intl";
import { Search as SearchInput } from "@components/global/new/Search/Search";

export default function Search({
  id,
  save,
  className,
  storageKey,
  multicolor,
  ...props
}: SearchPropsI) {
  const control = useSearchControl(storageKey, save, multicolor);
  const { formatMessage } = useIntl();

  return (
    <SearchInput
      allowClear
      id={id}
      wrapClassName={className}
      {...props}
      placeholder={formatMessage({ id: "general.search" })}
      value={control.search}
      onChange={(e) => control.setSearch(e.target.value)}
      onKeyDown={(e) => (e.key === "Enter" ? control.onSubmit() : null)}
    />
  );
}
